import { render, staticRenderFns } from "./btnCobiTime.vue?vue&type=template&id=677a33b6"
import script from "./btnCobiTime.vue?vue&type=script&lang=js"
export * from "./btnCobiTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677a33b6')) {
      api.createRecord('677a33b6', component.options)
    } else {
      api.reload('677a33b6', component.options)
    }
    module.hot.accept("./btnCobiTime.vue?vue&type=template&id=677a33b6", function () {
      api.rerender('677a33b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleComponents/btnCobiTime.vue"
export default component.exports